import SignUpVerification from './SignUpVerification';

export default SignUpVerification;
